import { render, staticRenderFns } from "./ExportPriceList.vue?vue&type=template&id=37d235c0&scoped=true"
import script from "./ExportPriceList.vue?vue&type=script&lang=js"
export * from "./ExportPriceList.vue?vue&type=script&lang=js"
import style0 from "./ExportPriceList.vue?vue&type=style&index=0&id=37d235c0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d235c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d235c0')) {
      api.createRecord('37d235c0', component.options)
    } else {
      api.reload('37d235c0', component.options)
    }
    module.hot.accept("./ExportPriceList.vue?vue&type=template&id=37d235c0&scoped=true", function () {
      api.rerender('37d235c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logged/ExportPriceList.vue"
export default component.exports